import { combineReducers } from 'redux';
import {UserSessionReducer} from './userSession'
import {LanguageReducer} from './language'
import {typeReservationReducer} from './typeReservation'
import {ResortsReducer} from './resorts'


const reducers = combineReducers({
    LanguageReducer,
    UserSessionReducer,
    typeReservationReducer,
    ResortsReducer
    
});
  
export default reducers;